export default __webpack_public_path__ + "static/media/IMG_20200723_204605.e2a0d6fa.jpg";